export type LayerType = "kml" | "geojson" | "marker";

export abstract class LayerComponent {
    layer?: L.Layer | undefined;
    checksum: string | undefined;

    constructor(
        readonly _map: L.Map,
        readonly id: string,
        readonly type: LayerType
    ) {}

    abstract hasChanged(newValue: any): boolean;

    attachLayer() {
        {
            if (this.layer) {
                this.layer.addTo(this._map);
            }
        }
    }

    detachLayer() {
        if (this.layer) {
            this.layer.removeFrom(this._map);
        }
    }
}
